exports = module.exports = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.gl-popover.bs-popover-bottom > .arrow::after {\n  border-bottom-color: #c4bae2;\n  top: 1px;\n}\n", ""]);

